const TopSection = () => {
  return (
    <div className="absolute top-0 left-0 w-full h-[350px] bg-dark -z-10" />
  );
};

export default TopSection;
